import { StacktraceScriptType } from '../../types';
export const PANORAMA_DATA_KEY = '__panoramaData';
export const BlacklistedStacktraceScriptTypes = [StacktraceScriptType.BROWSER_EXTENSION];
//# sourceMappingURL=sentry-plugin-constants.js.map